(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5986],{

/***/ 67309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homepage/whats-new/whats-new-page",
      function () {
        return __webpack_require__(29067);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ WhatsNewPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_pages_whats_new_whats_new_page_layout_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94862);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var components_templates_base_template__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38895);
/* harmony import */ var services_whats_new_page_whats_new_page_config_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(10696);
/* harmony import */ var _generated_templates_base_template_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79813);
/* harmony import */ var segments_desktop_embedded_layouts_whats_new_items_list_embedded_consts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10055);
/* harmony import */ var components_pages_whats_new_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29621);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var TITLE = "What's New - monday.com Product Updates";
var DESCRIPTION = "Find out what's new on monday.com products including feature releases, upgrades, and resources. Explore product updates by teams and benefits in a few clicks.";
var WhatsNewPage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(WhatsNewPage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(WhatsNewPage);
    function WhatsNewPage() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, WhatsNewPage);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_this), "buildMetaTags", function() {
            return {
                title: TITLE,
                description: DESCRIPTION
            };
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(WhatsNewPage, [
        {
            key: "render",
            value: function render() {
                var _mondayConfigToUse_data_boards__items_page, _mondayConfigToUse_data_boards_, _mondayConfigToUse_data_boards, _mondayConfigToUse_data;
                var _this_props = this.props, statusCode = _this_props.statusCode, props = _object_without_properties(_this_props, [
                    "statusCode"
                ]);
                var mondayConfig = props.mondayConfig, baseTemplateProps = _object_without_properties(props, [
                    "mondayConfig"
                ]);
                if (statusCode !== 200) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: statusCode
                });
                var mondayConfigToUse = mondayConfig || segments_desktop_embedded_layouts_whats_new_items_list_embedded_consts__WEBPACK_IMPORTED_MODULE_5__/* .staticMondayConfig */ .f;
                var items = mondayConfigToUse === null || mondayConfigToUse === void 0 ? void 0 : (_mondayConfigToUse_data = mondayConfigToUse.data) === null || _mondayConfigToUse_data === void 0 ? void 0 : (_mondayConfigToUse_data_boards = _mondayConfigToUse_data.boards) === null || _mondayConfigToUse_data_boards === void 0 ? void 0 : (_mondayConfigToUse_data_boards_ = _mondayConfigToUse_data_boards[0]) === null || _mondayConfigToUse_data_boards_ === void 0 ? void 0 : (_mondayConfigToUse_data_boards__items_page = _mondayConfigToUse_data_boards_.items_page) === null || _mondayConfigToUse_data_boards__items_page === void 0 ? void 0 : _mondayConfigToUse_data_boards__items_page.items;
                var itemsArrayObj = (0,components_pages_whats_new_utils__WEBPACK_IMPORTED_MODULE_6__/* .createItemsArray */ .Su)(items);
                var itemsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.itemsArray) || [];
                var releaseHighlightsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.releaseHighlightsArray) || [];
                var monthlyVideosSet = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.monthlyVideosSet) || {};
                var appsSet = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.appsSet) || {};
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_templates_base_template__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _object_spread_props(_object_spread({}, baseTemplateProps, (0,services_whats_new_page_whats_new_page_config_service__WEBPACK_IMPORTED_MODULE_13__/* .getWhatsNewPageConfig */ .E)(), this.buildMetaTags()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_pages_whats_new_whats_new_page_layout_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        itemsArray: itemsArray,
                        releaseHighlightsArray: releaseHighlightsArray,
                        monthlyVideosSet: monthlyVideosSet,
                        appsSet: appsSet
                    })
                }));
            }
        }
    ]);
    return WhatsNewPage;
}(_generated_templates_base_template_page__WEBPACK_IMPORTED_MODULE_4__["default"]);
var __N_SSP = true;



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7229,6602,390,8559,5365,4778,1489,9359,5657,932,4494,4961,1068,3211,9952,9160,2849,6022,3203,8885,8895,6227,3782,7554,3966,2377,9774,2888,179], function() { return __webpack_exec__(67309); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);